/**
 *----------------------------------------------------------------------
 * Copyright (c) 2023 - 2024 MEGEL
 *
 * data
 *
 * -----
 * @summary data
 * -----
 * Created Date: 09/02/2023 - 18:50:20
 * -----
 * Last Modified: 9/07/2024 - 15:15:33
 * -----
 *----------------------------------------------------------------------
*/

let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "William MEGEL",
    "role": "Architecte AWS / Chef de projet technique",
    "linkedinId":"92275524",
    "skypeid": "Your skypeid",
    "roleDescription1": "Gestion d'infrastructures AWS",
    "roleDescription2": "Mise en place d'architectures Serverless",
    "roleDescription3": "Construction d'usine à chatbots full serverless",
    "roleDescription4": "Conception et mise en oeuvre d'architectures Backends",
    "roleDescription5": "Architectures micro-services",
    "socialLinks":[
        {
          "id": 1,
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/william-megel-92275524/",
          "className":"fa fa-linkedin"
        },
        {
          "id": 2,
          "name":"twitter",
          "url":"https://twitter.com/wmegel",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme": [
      {id: 1, name: "Permis A, B"},
      {id: 2, name: "Ancien sportif de haut niveau (natation)."},
      {id: 3, name: "Ceinture marron de judo (passage ceinture noire en cours)."},
    ],
    "address":"wmegel@gmail.com",
    "website":"https://megel.net",
    "education":[
      {
        "id": 1,
        "UniversityName":"ISTY",
        "specialization":"Ingénieur génie logiciel",
        "MonthOfPassing":"",
        "YearOfPassing":"2000",
        "Achievements":"Major - Mention très bien"
      },
      {
        "id": 2,
        "UniversityName":"UHA",
        "specialization":"Licence de mathématiques pures",
        "MonthOfPassing":"",
        "YearOfPassing":"1996",
        "Achievements":"Mention"
      }
    ],
    "work":[
      {
        "id": 0,
        "CompanyName":"GENERALI",
        "icon": "images/brand/generali.png",
        "specialization":"Architecte technique / Responsable plateforme AWS",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2021 - Now",
        "Achievements":[
          "Gouvernance AWS",
          "Mise en place et maintient de l'infrastructure AWS",
          "Définition des postures de sécurité à appliquer sur l'organisation",
          "Monitorting / Observability"
        ],
        "tech": "[AWS, NodesJS, Java, RDS, CloudFront, Beanstalk, ELB, CodePipeline, Organization, Control Tower, Security Hub, Inspector, ...]"
      },
      {
        "id": 10,
        "CompanyName":"APICIL",
        "icon": "images/brand/apicil.png",
        "specialization":"Architecte cloud",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2021 - Now",
        "Achievements":[
          "Mise en place et maintient de l'infrastructure AWS",
          "Définition des postures de sécurité à appliquer sur les comptes AWS",
          "Conception des architectures des projets",
          "Monitorting / Observability"
        ],
        "tech": "[AWS, Java, NodesJS, Lambda, Step Function, RDS, CloudFront, Beanstalk, ELB, CodePipeline, Inspector, ...]"
      },
      {
        "id": 20,
        "CompanyName":"SOMEI (Groupe Veolia)",
        "icon": "images/brand/somei.jpg",
        "specialization":"Architecte technique / Responsable plateforme AWS",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2020 - Now",
        "Achievements":[
          "Gouvernance AWS",
          "Mise en place et maintient de l'infrastructure AWS.",
          "Définition des postures de sécurité à appliquer sur l'organisation",
          "Définition et standardiation des architectures des projets cloud",
          "Expertise cloud",
          "Gestion CI/CD des projets cloud"
        ],
        "tech": "[AWS, NodesJS, Python, Lambda, API Gateway, Step Function, DynamoDB, EventBridge, CloudFront, S3, CodePipeline, Organization, Control Tower, Security Hub, Inspector, ...]"
      },
      {
        "id": 30,
        "CompanyName":"HomeFriend by VEOLIA",
        "icon": "images/HomeFriend_logo_small.png",
        "specialization":"Architecte technique / Responsable plateforme AWS",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2016 - 2020",
        "Achievements":[
          "Gestion de l'infrastructure du groupe",
          "En charge de l'architecture technique de l'ensemble des projets du groupe.",
          "Proposition de solutions à base de services AWS (Serverless first)",
          "Conception et mise en oeuvre d'une usine à bots full serverless.",
          "Mise en place de la plateforme CI / CD du groupe (CodePipeline, CodeBuild, SonarQube)",
        ],
        "tech": "[AWS, NodesJS, Python, REST, ApiGateway, DynamoDB, CloudFront, EC2, ELB, CodePipeline, ...]"
      },
      {
        "id": 40,
        "CompanyName":"CHANEL",
        "icon": "https://upload.wikimedia.org/wikipedia/fr/3/34/Chanel_logo_complet.png",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2014 - 2015",
        "Achievements":[
          "Mise en oeuvre d'une plateforme de gestion des médias publicitaires du groupe.",
          "Gestion des commandes de ces médias sur les supports autorisés par les contrats.",
          "Responsable du projet. Responsable de l'architecture technique."
        ],
        "tech": "[J2EE, Tomcat 7, Angular JS, HP DAM MediaBin, Moteur de recherche IDOL, SSO]"
      },
      {
        "id": 50,
        "CompanyName":"SNCF RESEAUX",
        "icon": "https://upload.wikimedia.org/wikipedia/fr/thumb/e/ec/Logo_SNCF_R%C3%A9seau_2015.svg/langfr-135px-Logo_SNCF_R%C3%A9seau_2015.svg.png",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2012 - 2013",
        "Achievements":[
          "Mise en oeuvre du portail clients et partenaires du groupe.",
          "Encadrement technique et fonctionnel des équipes.",
          "Conception fonctionnelle, conception technique des modules JCMS.",
        ],
        "tech": "[Jalios JCM, Java J2EE, Tomcat, Oracle 11G, Fusion Charts]"
      },
      {
        "id": 60,
        "CompanyName":"ORANGE",
        "icon": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Orange_logo.svg/langfr-150px-Orange_logo.svg.png",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2010 - 2011",
        "Achievements":[
          "Chef de projet technique. Encadrement technique et fonctionnel.",
          "Mise en oeuvre de projets backend.",
          "Mise en oeuvre de projets fronts, mobiles",
        ],
        "tech": "[JBOSS, EJB, IOS, Android, HTML5, ADOBE FLEX, ADOBE LIVECYCLE, MAVEN, MYSQL]"
      },
      {
        "id": 70,
        "CompanyName":"DANONE",
        "icon": "images/brand/danone.jpeg",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2009",
        "Achievements":[
          "Mise en œuvre d’un système de gestion et suivi des engagements de dépense du groupe Danone.",
          "Chef de projet technique. Encadrement technique et fonctionnel",
          "Expertise BPM - Modélisation des processus métiers",
        ],
        "tech": "[BPM, Adobe Flex, Adobe Livecycle, Java, Websphere, IBM DB2, EJB3, Maven]"
      },
      {
        "id": 80,
        "CompanyName":"AIRBUS HELICOPTERS",
        "icon": "images/airbus.png",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2008 - 2009",
        "Achievements":[
          "Mise en œuvre d'une plateforme de suivi de l’état de santé des appareils.",
          "Exploitation des données fournies par les indicateurs installés sur les hélicoptères.",
          "Chef de projet technique. Encadrement technique et fonctionnel",
          "Conception technique et fonctionnelle.",
        ],
        "tech": "[J2EE, Hibernate, EJB3, NetWeaver, Adobe Flex, Flash 3D, LCDS, Flex Mobile (IOS/Android)]"
      },
      {
        "id": 8,
        "CompanyName":"BNP PARIBAS CARDIF",
        "icon": "https://s2.googleusercontent.com/s2/favicons?feature=youtube_channel&domain_url=https%3A%2F%2Fgroup.bnpparibas",
        "specialization":"Architecte / Chef de projet technique",
        "MonthOfLeaving":"",
        "YearOfLeaving":"2008 - 2009",
        "Achievements":[
          "Mise en place du socle technique du poste de travail nouvelle génération des agents BNP Paribas Assurances.",
          "Chef de projet technique. Encadrement technique et fonctionnel",
          "Conception technique et fonctionnelle.",
        ],
        "tech": "[Websphere, EJB3, Maven, Oracle, Tibco eProcess, Adobe Flex 3, Cairngorn,  BlazeDS]"
      }
    ],
    "skillsDescription":"",
    "skills":[
      {
        "skillname":"AWS"
      },
      {
        "skillname":"SERVERLESS"
      },
      {
        "skillname":"DEVOPS"
      },
      {
        "skillname":"ARCHITECTURE"
      },
      {
        "skillname":"SECURITY"
      },
      {
        "skillname":"MICRO-SERVICES"
      },
      {
        "skillname":"IAC"
      },
      {
        "skillname":"NODEJS"
      },
      {
        "skillname":"PYTHON"
      },
      {
        "skillname":"TEAM-LEAD"
      }
      
      
    ],
    "portfolio":[
      {
        "name":"TerraformAssociate",
        "description":"Hashicorp Terraform Associate",
        "imgurl":"images/portfolio/terraform_associate.png"
      },
      {
        "name":"EventsBadge",
        "description":"AWS Events Badge",
        "imgurl":"images/portfolio/aws_events_badge.png"
      },
      {
        "name":"ServerlessBadge",
        "description":"AWS Serverless Badge",
        "imgurl":"images/portfolio/Serverless_Badge_2.png"
      },
      {
        "name":"ArchitectCertif",
        "description":"Certified Solutions Architect course",
        "imgurl":"images/portfolio/certif_certified_architect.jpg"
      },
      {
        "name":"CloudPractitionerCertif",
        "description":"Certified Cloud Practitioner",  
        "imgurl":"images/portfolio/certif_cloud_practitioner.jpg"
      },
      {
        "name":"Security",
        "description":"AWS Security Speciality",
        "imgurl":"images/portfolio/AWS-Security-Speciality.jpg"
      },
      {
        "name":"Devops",
        "description":"Certified Devops",
        "imgurl":"images/portfolio/Udemy-AWS-Certified_Devops-2022.png"
      },
      {
        "name":"SysOps",
        "description":"Certified SysOps",
        "imgurl":"images/portfolio/sysops.jpg"
      },
      {
        "name":"DevOps",
        "description":"Certified DevOps",
        "imgurl":"images/portfolio/devops.jpg"
      },
      {
        "name":"WellArchitected",
        "description":"Well Architected Framework",  
        "imgurl":"images/portfolio/wellArchitectedFramework.jpg"
      },
      {
        "name":"Architect",
        "description":"Certified Solutions Architect",
        "imgurl":"images/portfolio/architect.jpg"
      },
      {
        "name":"Developer",
        "description":"Certified AWS Developer",
        "imgurl":"images/portfolio/aws_dev.jpg"
      },
      {
        "name":"Alexa",
        "description":"Certified Alexa skills builder",  
        "imgurl":"images/portfolio/alexa.jpg"
      }
    ],
    "testimonials":[
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      },
      {
        "description":"This is a sample testimonial",
        "name":"Some technical guy"
      }
    ]
  }
  
  export default resumeData